import { axios } from '@/api/axios';

import { REQUEST } from '@/constants/api';

import { AccountTypeDetails } from '@/types/api/account';

import { buildRequestParams } from '@/utils/api';

export const getAccountTypes = async (operationId?: string) => {
  const result = await axios.get<AccountTypeDetails[]>(
    `${REQUEST.ACCOUNT.TYPES}${buildRequestParams({ operationId })}`,
  );

  return result.data;
};

export const batchSetAccountTypes = async (accountTypeIds: string[]) => {
  const result = await axios.post(REQUEST.ACCOUNT.TYPES_BATCH, {
    accountTypeIds,
  });

  return result.data;
};
